import { RouterView } from "vue-router";
import { EntityNotes } from "@modernary/mui/components/note";
import { EntityAudit } from "@modernary/mui/components/audit";

/** @type {import('vue-router').RouterOptions['routes']} */

const names = {
  accounts: "Account.Accounts",
  list: "Account.AccountList",
  new: "Account.AccountNew",
  base: "Account.AccountBase",
  view: "Account.AccountView",
  edit: "Account.AccountEdit",
  notes: "Account.AccountNotes",
  noteEdit: "Account.AccountNoteEdit",
  noteNew: "Account.AccountNoteNew",
  audit: "Account.AccountAudit",
};

export { names as accountRouteNames };

const accountRoutes = [
  {
    path: "/account",
    name: names.accounts,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Accounts",
          lookupGroups: ["AccountActivityCode"],
        },
        component: () => import("@/views/account/AccountList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/account/AccountBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Account", isNew: true },
            component: () => import("@/views/account/AccountEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/account/AccountBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Account View" },
            component: () => import("@/views/account/AccountView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Account Edit", isForm: true },
            component: () => import("@/views/account/AccountEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Account Notes" },
            component: {
              render: () => <EntityNotes idField="accountId" routeNamePrefix="Account.AccountNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Account Note", isForm: true },
            component: () => import("@/views/account/AccountNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Account Note", isForm: true },
            component: () => import("@/views/account/AccountNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Account Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Account" />,
            },
          },
        ],
      },
    ],
  },
];
export default accountRoutes;
